import { Loader2Icon } from "lucide-react"

import { cn } from "@/lib/utils-client"

// Spinner for smaller states like buttons and forms
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

// Spinner that takes up the full page loading state
function SpinnerFullPage({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("flex min-h-screen items-center justify-center", className)}
      {...props}
    >
      <Spinner className="size-6" />
    </div>
  )
}

export { Spinner, SpinnerFullPage }
